import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CertificateUploadService {
  public resourceUrl = environment.apiConfig.uri + 'api/zertifikate';

  constructor(private http: HttpClient) {}

  post(base64: string): Observable<string> {
    return this.http.post(this.resourceUrl, base64, {
      headers: { 'Content-Type': 'text/plain' },
      responseType: 'text',
    });
  }

  delete(id: string): Observable<HttpResponse<void>> {
    return this.http.delete<void>(`${this.resourceUrl}/${id}`, {
      observe: 'response',
    });
  }

  postName(nameCertificate: string): Observable<any> {
    return this.http.post(
      `${environment.apiConfig.uri}api/zertifikatsname/${nameCertificate}`,
      {
        observe: 'response',
      },
    );
  }
}
